// extracted by mini-css-extract-plugin
export var button = "PageDataBodyIllustrationsCtas-module--button--BlFzx";
export var cards = "PageDataBodyIllustrationsCtas-module--cards--yyh79";
export var container = "PageDataBodyIllustrationsCtas-module--container--KnR1e";
export var content = "PageDataBodyIllustrationsCtas-module--content--mnh9I";
export var heading = "PageDataBodyIllustrationsCtas-module--heading--qgplC";
export var wheel = "PageDataBodyIllustrationsCtas-module--wheel--NZU6d";
export var wheelContainer = "PageDataBodyIllustrationsCtas-module--wheelContainer--W6y6e";